import { makeStyles } from '@material-ui/core';
import React from 'react';
import Footer from '../../../components/footer';
import Header from '../../../components/header';
import { COLORS } from '../../../constants/colors';

const useStyles = makeStyles({
  body: {
    minHeight: '67.7vh',
    backgroundColor: COLORS.grayScale[2],
  },
});

const PublicPage = ({ children, onEdit, onDelete, onCancel }) => {
  const classes = useStyles();
  return (
    <>
      <Header withActions onEdit={onEdit} onDelete={onDelete} onCancel={onCancel}/>
      <section className={classes.body}>{children}</section>
      <Footer withFooterActions={true} />
    </>
  );
};

export default PublicPage;
